'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _webApiClientSingleton = require('../webApiClientSingleton');

var _webApiClientSingleton2 = _interopRequireDefault(_webApiClientSingleton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logError = function logError(message) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _webApiClientSingleton2.default.instance.logging.errorLog({
    message: message,
    context: { error: error.message }
  });
};

exports.default = logError;
//# sourceMappingURL=logError.js.map